module.exports = __webpack_public_path__ + "static/media/selfdefence.92969143.jpg";